import { useMemo } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import {
  addImageSizeParametersToUrl,
  Carousel,
  Image,
  useMediaQuery,
} from '@lounge-fe/ui-kit'
import { PhoneMockup } from '@/components/PhoneMockup'
import { GiftCardMediaProps } from './types'
import { captureException } from '@sentry/react'

export const GiftCardMedia = ({ image }: GiftCardMediaProps) => {
  const [emblaRef, embla] = useEmblaCarousel({ align: 'start', loop: true })
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.md})`)

  const imageURL = useMemo(
    () =>
      addImageSizeParametersToUrl({
        src: image.src,
        width: 300,
        height: 600,
        crop: 'center',
        onError: captureException,
      }),
    [image.src],
  )

  const phoneMockupImage = (
    <div className="aspect-[2/3] 2xl:aspect-[unset] 2xl:h-[calc(100vh_-_var(--header-height))] flex justify-center items-center bg-surface-secondary-default col-span-2">
      <PhoneMockup
        className="h-[600px] max-h-[calc(100%-48px)]"
        src={imageURL}
      />
    </div>
  )

  const variantImage = (
    <div className="col-span-2">
      <Image
        className="aspect-[2/3] 2xl:aspect-[unset] 2xl:h-[calc(100vh_-_var(--header-height))] object-cover w-full"
        data={{
          src: image.src,
          width: 480,
          height: 672,
          crop: 'center',
        }}
      />
    </div>
  )

  if (isDesktop) {
    return (
      <div className="grid grid-cols-1 auto-rows-min gap-1 self-start sticky flex-1">
        {phoneMockupImage}
        {variantImage}
      </div>
    )
  }

  return (
    <Carousel emblaRef={emblaRef} embla={embla}>
      <Carousel.Viewport className="relative">
        <Carousel.Container className="auto-cols-[100%]">
          <Carousel.Slide index={0}>{phoneMockupImage}</Carousel.Slide>
          <Carousel.Slide index={1}>{variantImage}</Carousel.Slide>
        </Carousel.Container>
      </Carousel.Viewport>
      <Carousel.Progress />
    </Carousel>
  )
}
